var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7016 2.10701L10.4542 3.35444L13.2826 6.18286L14.5301 4.93544C14.5379 4.91102 14.5465 4.88244 14.5552 4.85009C14.5919 4.71463 14.63 4.51995 14.6331 4.29127C14.6393 3.84718 14.5167 3.26025 13.9467 2.69034C13.3768 2.12043 12.7899 1.99783 12.3458 2.00395C12.1171 2.00711 11.9225 2.04514 11.787 2.08184C11.7546 2.0906 11.7261 2.09918 11.7016 2.10701ZM15.1038 5.30449C15.7105 5.58081 15.7107 5.5805 15.7108 5.58017L15.7111 5.57949L15.7118 5.57801L15.7133 5.57456L15.7172 5.56579C15.7201 5.55911 15.7237 5.55077 15.7278 5.54083C15.736 5.52095 15.7465 5.49461 15.7585 5.46227C15.7824 5.3977 15.8124 5.30856 15.8422 5.19872C15.9014 4.98011 15.9613 4.67278 15.9663 4.30966C15.9765 3.57013 15.7563 2.61428 14.8896 1.74753C14.0228 0.880783 13.067 0.660544 12.3274 0.670744C11.9643 0.675753 11.657 0.73567 11.4384 0.794888C11.3285 0.824645 11.2394 0.854684 11.1748 0.878587C11.1425 0.890559 11.1161 0.901052 11.0963 0.909287C11.0863 0.913407 11.078 0.916968 11.0713 0.919876L11.0625 0.923737L11.0591 0.925279L11.0576 0.925949L11.0569 0.926259C11.0566 0.926406 11.0563 0.926551 11.3326 1.53326L11.0563 0.926551L10.9465 0.976551L1.09864 10.8244L0.455811 16.1813L5.81268 15.5384L15.6605 5.6906L15.7105 5.58081L15.1038 5.30449ZM12.3398 7.12567L9.51141 4.29724L2.36753 11.4411L1.98183 14.6553L5.19595 14.2696L12.3398 7.12567Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4580dade26e3fd88e05cfbc2a9dc21d1.svg";
export { ForwardRef as ReactComponent };